import { Component, EventEmitter, Inject, Input, OnInit, Output, Optional, OnChanges, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { copyToClipboard, presentDialog, presentLoading } from 'src/global';
import { SelectProfileIconComponent } from '../dialogs/select-profile-icon/select-profile-icon.component';
import { Platform } from '@ionic/angular';
import { UserContact } from 'node_js/models/tables/user_contact';
import { UserContactService } from 'src/app/services/user-contact.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { UserContactStatus } from 'node_js/models/enums/user-contact-status';
import { UserNotification } from 'node_js/models/tables/user_notification';
import { UserContactRequestInfo } from 'node_js/models/business/user_contact_request_info';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MainSliderSection } from 'src/app/pages/dashboard/dashboard.page';
import { LiveUpdatesService } from 'src/app/services/live-updates.service';
import { UserNotificationContactRequest } from 'node_js/models/business/user_notification_settings/user-notification-contact-request';
import { AndroidBackPriority } from 'node_js/models/enums/android-back-priority';
import { TutorialService } from 'src/app/services/tutorial.service';

enum AddContactMethod {
  code,
  email
}

export enum ContactInfoType {
  CREATING,
  UPDATING,
  PENDINGNOTIFICATION
}

@Component({
  selector: 'contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent  implements OnInit, OnChanges {

  copyToClipboard = copyToClipboard

  @Input() initialRender:boolean = false;

  // New input for contact request
  @Input() userNotificationContactRequest:UserNotificationContactRequest | null = null;
 
  @Output() changeSlideEvent: EventEmitter<MainSliderSection> = new EventEmitter();
  @Output() contactRequestProcessed: EventEmitter<void> = new EventEmitter();
  currentContactInfoType:ContactInfoType = ContactInfoType.CREATING; 
  userContact:UserContact;
  contactRequestId:string;

  AddContactMethod = AddContactMethod;
  addContactMethod:AddContactMethod = AddContactMethod.email;

  ContactInfoType = ContactInfoType;
  UserContactStatus = UserContactStatus;
  newContactFriendCode:string = "";
  newContactEmail:string = "";

  contactRequestDetailsLoading = false;

  nicknameHasError = false;
  friendCodeHasError = false;
  emailHasError = false;

  // Property to store the dialog reference when opened as a dialog
  dialogRef: MatDialogRef<any> | null = null;
  
  // Store the back button subscription for cleanup
  private backButtonSubscription: any;

  // Setter method for dialogRef
  setDialogRef(ref: MatDialogRef<any>) {
    this.dialogRef = ref;
    console.log("DialogRef set in component:", this.dialogRef);
  }

 
  constructor(
    private matDialog:MatDialog, 
    private platform:Platform, 
    private userContactService:UserContactService,
    protected userAuthService:UserAuthService, 
    protected matSnackBar:MatSnackBar, 
    private liveUpdatesService:LiveUpdatesService,
    private tutorialService: TutorialService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any // <-- Make this optional
  ) { 
    // If opened as a dialog, get the userNotificationContactRequest from data
    if (data?.userNotificationContactRequest) {
      this.userNotificationContactRequest = data.userNotificationContactRequest;
    }
    
    console.log("ContactInfoComponent constructor - data:", data);
  }

  ngOnInit() {

    if (this.initialRender == true){
      return;
    }

    console.log("got contact",this.userContactService.selectedUserContact)
    if (this.userContactService.selectedUserContact){
      this.userContact = JSON.parse(JSON.stringify(this.userContactService.selectedUserContact));
      this.currentContactInfoType = ContactInfoType.UPDATING;
    }

    if (this.currentContactInfoType == ContactInfoType.CREATING || this.currentContactInfoType == ContactInfoType.PENDINGNOTIFICATION){
      this.userContact = this.userContactService.createBlankUserContact(this.userAuthService.currentUserComplete.user.id);
    }

    this.handleBackButton();
    
    this.liveUpdatesService.afterUserContactUpdatedObservable.subscribe((userContact:UserContact)=>{
      console.log("UPDATED USER CONTACT",userContact)
      if (userContact.id == this.userContact.id){
        this.userContact = userContact
      }
    })

    if (this.userNotificationContactRequest){
      console.log('ContactInfoComponent: Processing contact request in ngOnInit');
      this.setContactRequest(this.userNotificationContactRequest);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Handle changes to userNotificationContactRequest input
    if (changes['userNotificationContactRequest'] && !changes['userNotificationContactRequest'].firstChange) {
      console.log('ContactInfoComponent: userNotificationContactRequest changed:', this.userNotificationContactRequest);
      if (this.userNotificationContactRequest) {
        console.log('ContactInfoComponent: Processing contact request in ngOnChanges');
        this.setContactRequest(this.userNotificationContactRequest);
      }
    }
  }

  setUpdatingContact(userContact:UserContact){
    this.userContact = userContact;
    this.currentContactInfoType = ContactInfoType.UPDATING;
  }

  setContactRequest(userNotificationContactRequest:UserNotificationContactRequest){
    this.contactRequestId = userNotificationContactRequest.userContactRequestId;
    this.userContact.nickname = userNotificationContactRequest.nickname;
    if (this.contactRequestId){
      this.currentContactInfoType = ContactInfoType.PENDINGNOTIFICATION;
      this.contactRequestDetailsLoading = true;
      console.log("TESTING",this.contactRequestId);

      //Get contact request user contact display name and friend code
      this.userContactService.getContactRequestDetailsById(this.contactRequestId,this.userAuthService).then((userContactRequestInfo:UserContactRequestInfo)=>{
        console.log("[DupUser] USER CONTACT REQUEST INFO RECEIVED",userContactRequestInfo)
        this.userContact.nickname = userContactRequestInfo.displayName;
        this.newContactFriendCode = userContactRequestInfo.friendCode;

        console.log(this.userContact)

        // Emit event to notify that contact request has been processed
        this.contactRequestProcessed.emit();
      }).finally(() => {
        this.contactRequestDetailsLoading = false;
      });
    }
  }

  exitComponentFunc(){
    console.log("EXITING COMPONENT")
    // If opened as a dialog, close the dialog
    console.log("DATA",this.data)
    console.log("DIALOG REF",this.dialogRef)
    if (this.dialogRef) {
      console.log("CLOSING DIALOG")
      this.dialogRef.close();
      return;
    }
    // Otherwise, emit the event to change the slide
    this.changeSlideEvent.emit(MainSliderSection.CONTACTS);
  }

  handleBackButton(){
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(AndroidBackPriority.DIALOG, () => {
      this.exitComponentFunc();
    });
  }

  deleteContact(){
    let loadingRef = presentLoading(this.matDialog);
    this.userContactService.deleteContact(this.userContact,this.userAuthService).then(()=>{
      this.userContactService.selectedUserContact = null;
      this.exitComponentFunc();
    }).finally(()=>{
      loadingRef.close();
    });
  }

  finish(){

    console.log("FIN",this.userContact)

    if (this.currentContactInfoType == ContactInfoType.CREATING) {
      if (this.addContactMethod == AddContactMethod.email && this.newContactEmail) {
        this.tutorialService.noteContactEmailEntered();
      } else if (this.addContactMethod == AddContactMethod.code && this.newContactFriendCode) {
        this.tutorialService.noteContactCodeEntered();
      }
    }

    this.nicknameHasError = false;
    this.friendCodeHasError = false;

    if (this.userContact.nickname == "" || this.userContact.nickname.length > 50){
      this.nicknameHasError = true;
      return;
    }
    
    if (this.currentContactInfoType == ContactInfoType.CREATING){
      if (this.addContactMethod == AddContactMethod.code){
        this.newContactEmail = "";
        if (this.newContactFriendCode == ""){
          this.friendCodeHasError = true;
          return;
        }
      }
      else if (this.addContactMethod == AddContactMethod.email){
        this.newContactFriendCode = "";
        if (this.newContactEmail == ""){
          this.emailHasError = true;
          return;
        }
      }
      
      
    }

   
    let loadingRef = presentLoading(this.matDialog);
    if (this.currentContactInfoType == ContactInfoType.CREATING || this.currentContactInfoType == ContactInfoType.PENDINGNOTIFICATION || (this.currentContactInfoType == ContactInfoType.UPDATING && this.userContact.status == UserContactStatus.DELETED)){

      
      console.log("[DupUser] SENDING",this.userContact)
      console.log("[DupUser] FRIEND CODE",this.newContactFriendCode)
      console.log("[DupUser] EMAIL",this.newContactEmail)
      this.userContactService.createContact(this.userContact,this.newContactFriendCode,this.newContactEmail,this.userAuthService).then(async ()=>{
    
        setTimeout(()=>{
          this.tutorialService.noteContactRequestSent();
          this.exitComponentFunc();
        },100)

      }).finally(()=>{
        loadingRef.close();
      })
    }
    else{
      this.userContactService.updateContact(this.userContact,this.userAuthService).then(()=>{

    

      }).finally(()=>{
        loadingRef.close();
        this.exitComponentFunc();

      })
    }
  }

  sendContactRequestToDeletedContact(){

  }

  ngOnDestroy(){
    this.userContactService.selectedUserContact = null;
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
  }

  onMethodChange(event: any) {
    this.tutorialService.noteContactMethodSelected(event.value === AddContactMethod.email ? 'email' : 'code');
  }

}
